<template>
  <v-layout row wrap my-3 mx-5>
    <v-dialog
      v-model="dialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please stand by.. importing {{upload}}%
          <v-progress-linear
            v-model="upload"
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-flex xs12>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary">
          Import Lead Data
        </v-card-title>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
              :disabled="loading"
            >
              Select File
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <!--  -->
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap>
          <v-progress-linear class="px-3" v-if=" upload > 0 && upload < 100" v-model="upload" height="50px" color="primary"></v-progress-linear>
        </v-layout>
        <v-card-actions class="px-3">
          <v-spacer></v-spacer>
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="uploadFile()"
            >
              upload
            <v-icon right dark>cloud_upload</v-icon> 
          </v-btn>
        </v-card-actions> 
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import {firebase, db, auth, storageRef} from '@/fb';
import { getRandomInt, randomString, getCDate, check } from '@/customFunction';


export default {
  data() {
    return {
      url:null,
      name:null,
      file:null,
      loading:false,
      upload:null,
      csv:null,
      detailedViewsHeaders:[],
      detailedViews:[],
      selected:[],
      dialog:false,
      count:0
    }
  },
  methods: {
    
    saveAll(){
      if (this.selected.length == 0) {
        return
      }
      this.loading = true
      let count = 0
      let unique = 0
      this.selected.forEach(contact=>{
        for (const key in contact) {
          if (contact.hasOwnProperty(key)) {
            const val = contact[key];
            contact[key
            .toLowerCase()
            .replace(/ /g, '_')
            .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '_')
            ] = val
            delete contact[key]
          }
        }
        let lead = Object.assign(contact, {
          import_date:getCDate(),
          email:'',
        })
        db.ref('leads')
        .push(lead)
        .then(x=>{
          count++
          unique++
          if (count == this.selected.length) {
            this.$emit('snackbarNotification', `${unique} Leads Stored Successfully`, 'success')
            this.loading = false
            this.goTo('/')
          }
        })
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    pickFile () {
      this.$refs.file.click ()
    },
    
    loadFile(){
      this.detailedViewsHeaders = []
      this.detailedViews = []
      console.log('------------------------------------');
      console.log(this.csv);
      console.log('------------------------------------');
      this.csv.meta.fields.forEach(el => {
        this.detailedViewsHeaders.push({
          text:el
          .toUpperCase()
          .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '_')
          .replace(/ /g, '_'),
          value:el
          .toLowerCase()
          .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '_')
          .replace(/ /g, '_')
        })
      });
      this.detailedViews = this.csv.data
    },
    uploadFile(){
      this.dialog = true
      var file = this.file
      var metadata = {
        contentType: 'text/csv'
      };
      let filename = 'leadsimport.csv'
      var uploadTask = storageRef.child(filename).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.upload = progress
                }, (error) =>{
        switch (error.code) {
          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
          console.log('File available at', downloadURL);
          this.$emit('snackbarNotification', `Import Started Successfully`, 'success')
          this.goTo('/')
          this.dialog = false
        });
      });
    },
    onFilePicked (e) {
      
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.name = files[0].name
          this.url = fr.result
          this.file = files[0] // this is an image file that can be sent to server...
          // Papa.parse(this.file, {
          //   header: true,
          //   encoding: "utf-8",
          //   complete: (d)=>{
          //     this.csv = d
          //     let headers = []
          //     this.csv.meta.fields.forEach(el => {
          //       headers.push(el
          //         .toUpperCase()
          //         .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '_')
          //         .replace(/ /g, '_'))
          //     });
          //     let count = 0
          //     let unique = 0
          //     this.csv.data.forEach(r=>{
          //       for (const key in r) {
          //         if (r.hasOwnProperty(key)) {
          //           const val = r[key];
          //           r[key.toLowerCase()
          //           .replace(/ /g, '_')
          //           .replace(/[-!$%^&*()_+|~=`{}\[\]:";'<>?,.\/]/g, '_')] = val
          //           delete r[key]
          //         }
          //       }
          //       console.log(r)
          //       db.ref('leads')
          //       .push(r)
          //       .then(x=>{
          //         count++
          //         this.count++
          //         unique++
          //         if (count == this.csv.data.length) {
          //           this.$emit('snackbarNotification', `${unique} Leads Stored Successfully`, 'success')
          //           this.loading = false
          //           this.dialog = false
          //           this.goTo('/')
          //         }
          //       })
          //     })
          //   }
          // })
        })
      } else {
        this.name = null
        this.file = null
        this.url = null
      }
    },
  },
  watch:{
    selected(){
      console.log(this.selected)
    }
  },
  created() {
  }
}
</script>

<style>

</style>
